export default "__VITE_ASSET__kAO3tDYC__"